/* eslint-disable */
import _m0 from 'protobufjs/minimal';

export const protobufPackage = 'com.celertech.type';

export interface DynamicParameter {
    key: string;
    value: string;
}

export interface DynamicParameters {
    name: string;
    parameters: DynamicParameter[];
    dynamicParameters: DynamicParameters[];
}

function createBaseDynamicParameter(): DynamicParameter {
    return { key: '', value: '' };
}

export const DynamicParameter = {
    encode(message: DynamicParameter, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.key !== '') {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== '') {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): DynamicParameter {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDynamicParameter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<DynamicParameter>): DynamicParameter {
        const message = createBaseDynamicParameter();
        message.key = object.key ?? '';
        message.value = object.value ?? '';
        return message;
    }
};

function createBaseDynamicParameters(): DynamicParameters {
    return { name: '', parameters: [], dynamicParameters: [] };
}

export const DynamicParameters = {
    encode(message: DynamicParameters, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.name !== '') {
            writer.uint32(10).string(message.name);
        }
        for (const v of message.parameters) {
            DynamicParameter.encode(v!, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.dynamicParameters) {
            DynamicParameters.encode(v!, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): DynamicParameters {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDynamicParameters();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.parameters.push(DynamicParameter.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.dynamicParameters.push(DynamicParameters.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<DynamicParameters>): DynamicParameters {
        const message = createBaseDynamicParameters();
        message.name = object.name ?? '';
        message.parameters = object.parameters?.map((e) => DynamicParameter.fromPartial(e)) || [];
        message.dynamicParameters = object.dynamicParameters?.map((e) => DynamicParameters.fromPartial(e)) || [];
        return message;
    }
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin
    ? T
    : T extends Array<infer U>
    ? Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
    ? ReadonlyArray<DeepPartial<U>>
    : T extends {}
    ? { [K in keyof T]?: DeepPartial<T[K]> }
    : Partial<T>;
